import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconQuickSearch: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconQuickSearch"><Path d="M18 17L21.5 20.5" stroke="currentColor"/><Path d="M12 19.5C16.6944 19.5 20.5 15.6944 20.5 11C20.5 6.30558 16.6944 2.5 12 2.5C7.30558 2.5 3.5 6.30558 3.5 11" stroke="currentColor"/><Path d="M3 16.875L8.78571 10L8.14286 14.125H12L6.21429 21L6.85714 16.875H3Z" fill="currentColor"/></CentralIconBase>;
});

export default IconQuickSearch;
